import { useGetLocationsByOrgIdQuery, } from '../../../generated/graphql';
/**
 * Manages location + level selection and loads location details (including levels) for the active location.
 * If only `defaultLevelId` is provided, loads the level’s parent location via GraphQL.
 */
export function useGetLocationsForOrg(_a) {
    var _b, _c;
    var currentOrgId = _a.currentOrgId, skip = _a.skip;
    var _d = useGetLocationsByOrgIdQuery({
        variables: { id: currentOrgId },
        skip: !currentOrgId || skip,
    }), data = _d.data, loading = _d.loading, error = _d.error;
    var locations = (_c = (_b = data === null || data === void 0 ? void 0 : data.getOrganizationById) === null || _b === void 0 ? void 0 : _b.locations) !== null && _c !== void 0 ? _c : [];
    return {
        locations: locations,
        loading: loading,
        error: error,
    };
}
